<template>
  <div class="modal fade" tabindex="-1" ref="modal_compartilhamento">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header bg-primary">
          <div style="flex: 1">
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px;">
              <h3 class="modal-title text-white mb-0">
                Compartilhamento de Dispositivo
              </h3>
              <button
                type="button"
                class="btn-close"
                @click="closeModal"
              ></button>
            </div>
            <small class="text-white-50" v-if="!limiteAtingido">
              Você tem no máximo {{ limite }} compartilhamentos por propriedade.
            </small>
            <small class="text-warning" v-if="limiteAtingido">
              <i class="bx bx-warning me-1"></i>
              O número de compartilhamentos foi excedido.
            </small>
          </div>
        </div>
        <div class="modal-body">
          <!-- Compartilhados -->
          <div v-if="sharedUsers.length > 0" class="mb-4">
            <h6 class="mb-3">
              Usuários com acesso
            </h6>
            <div class="shared-users-container">
              <div
                v-for="(user, index) in sharedUsers"
                :key="index"
                class="shared-user-card"
              >
                <div class="user-info">
                  <div class="user-avatar">
                    <i class="bx bx-user"></i>
                  </div>
                  <div class="user-details">
                    <span class="user-name">{{ user.Nome }}</span>
                    <small class="user-code">Código: {{ user.token }}</small>
                  </div>
                </div>
                <button
                  class="btn btn-outline-danger btn-sm remove-btn"
                  @click="removeUser(user.token)"
                  title="Remover acesso"
                  :disabled="isLoading"
                >
                  <i class="bx bx-trash"></i>
                </button>
              </div>
            </div>
            <hr class="my-4" />
          </div>

          <div v-if="!limiteAtingido">
            <h6 class="mb-3">
              Compartilhar com novo usuário
            </h6>
            
            <!-- Campo de busca -->
            <div class="search-section">
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Digite o código do usuário"
                  v-model="userCode"
                  @keyup.enter="searchUser"
                  :disabled="isLoading"
                />
                <LoadButton
                  @click="searchUser"
                  ref="btn_buscar"
                  class="btn btn-outline-success"
                  text="Buscar"
                  loadtext="Buscando..."
                  style="border-left: none;"
                  :disabled="!userCode.trim()"
                >
                  <i class="bx bx-search me-1"></i>
                </LoadButton>
              </div>
              <small class="form-text text-muted">
                <i class="bx bx-info-circle me-1"></i>
                Informe o código do usuário para compartilhar o dispositivo
              </small>
            </div>

            <!-- User encontrado -->
            <div v-if="foundUser" class="shared-user-card confirmation-style">
              <div class="user-info">
                <div class="user-avatar confirmation-avatar">
                  <i class="bx bx-user-check"></i>
                </div>
                <div class="user-details">
                  <span class="user-name">Usuário encontrado!</span>
                  <small class="user-code text-muted">{{ foundUserName }}</small>
                </div>
              </div>
              <div class="action-buttons">
                <button 
                  class="btn btn-outline-secondary confirmation-btn me-1" 
                  @click="cancelShare"
                  title="Cancelar"
                  :disabled="isLoading"
                >
                  <i class="bx bx-x"></i>
                </button>
                <LoadButton
                  @click="shareWithUser"
                  ref="btn_compartilhar"
                  class="btn btn-success confirmation-btn"
                  text="Compartilhar"
                  loadtext="Compartilhando..."
                >
                  <i class="bx bx-check me-1"></i>
                </LoadButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Alert ref="alert"></Alert>
</template>

<script>
import LoadButton from "../form/LoadButton.vue";
import Alert from "../Alert.vue";

export default {
  name: "ShareDeviceModal",
  components: {
    LoadButton,
    Alert,
  },
  props: {
    deviceId: {
      type: [Number, String],
      required: false,
      default: null
    }
  },
  data() {
    return {
      isLoading: false,
      currentDeviceId: null,
      sharedUsers: [],
      limite: null,
      limiteAtingido: false,
      userCode: "",
      foundUser: false,
      foundUserName: null,
    };
  },
  methods: {
    open(deviceId = null) {
      this.currentDeviceId = deviceId || this.deviceId;
      this.loadSharedUsers();
      $(this.$refs.modal_compartilhamento).modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    closeModal() {
      this.resetForm();
      $(this.$refs.modal_compartilhamento).modal("hide");
      this.$emit("closed");
    },

    resetForm() {
      this.userCode = "";
      this.foundUser = false;
      this.foundUserName = null;
      this.isLoading = false;
    },

    async loadSharedUsers() {
      try {
        this.isLoading = true;
        const response = await this.urlPost("/Devices/FetchSharedUserName", {
          QrCodeId: this.currentDeviceId
        });
        
        this.sharedUsers = response.data.Usuario || [];
        this.limite = response.data.Limite;
        this.limiteAtingido = response.data.LimiteAtingido;
        
        this.$emit("users-loaded", {
          users: this.sharedUsers,
          limite: this.limite,
          limiteAtingido: this.limiteAtingido
        });
      } catch (error) {
        this.handleError(error, "Erro ao carregar usuários compartilhados");
      } finally {
        this.isLoading = false;
      }
    },

    async searchUser() {
      if (!this.userCode.trim()) return;

      try {
        this.isLoading = true;
        const response = await this.urlPost("/Devices/FetchUserNameToShare", {
          QrCodeId: this.currentDeviceId,
          CodigoCompartilhado: this.userCode
        });
        
        this.foundUser = true;
        this.foundUserName = response.data.NomeDispositivo;
        
        this.$emit("user-found", {
          code: this.userCode,
          name: this.foundUserName
        });
      } catch (error) {
        this.handleSearchError(error);
      } finally {
        this.isLoading = false;
      }
    },

    async shareWithUser() {
      try {
        this.isLoading = true;
        const response = await this.urlPost("/Devices/Share", {
          QrCodeId: this.currentDeviceId,
          CodigoCompartilhado: this.userCode
        });

        if (response.data.Usuario) {
          this.sharedUsers.push(response.data.Usuario);
        }
        
        this.limiteAtingido = response.data.LimiteAtingido;
        
        this.$refs.alert.show(
          "Sucesso",
          "Dispositivo compartilhado com sucesso!",
          null,
          5000,
          "bg-success"
        );

        this.$emit("user-shared", {
          user: response.data.Usuario,
          limiteAtingido: this.limiteAtingido
        });

        // Resetar busca
        this.cancelShare();
      } catch (error) {
        this.handleShareError(error);
      } finally {
        this.isLoading = false;
      }
    },

    async removeUser(userToken) {
      try {
        this.isLoading = true;
        const response = await this.urlPost("/AdminUser/RemoveSharedUser", {
          QrCodeId: this.currentDeviceId,
          CodigoCompartilhado: userToken
        });

        // Remover da lista
        this.sharedUsers = this.sharedUsers.filter(
          user => user.token !== userToken
        );
        
        this.limiteAtingido = response.data.LimiteAtingido;

        this.$refs.alert.show(
          "Sucesso",
          "Usuário removido do compartilhamento!",
          null,
          3000,
          "bg-success"
        );

        this.$emit("user-removed", {
          userToken,
          limiteAtingido: this.limiteAtingido
        });
      } catch (error) {
        this.handleError(error, "Erro ao remover usuário");
      } finally {
        this.isLoading = false;
      }
    },

    cancelShare() {
      this.userCode = "";
      this.foundUser = false;
      this.foundUserName = null;
    },

    handleSearchError(error) {
      this.userCode = "";
      
      if (error.response?.status === 406) {
        this.$refs.alert.show(
          "Erro",
          "Não é possível compartilhar consigo mesmo",
          null,
          3000,
          "bg-danger"
        );
      } else if (error.response?.status === 400) {
        this.$refs.alert.show(
          "Erro",
          "Erro no processo de busca",
          null,
          3000,
          "bg-danger"
        );
      } else {
        this.$refs.alert.show(
          "Erro",
          "Código de usuário inválido!",
          null,
          3000,
          "bg-danger"
        );
      }
    },

    handleShareError(error) {
      this.userCode = "";
      this.foundUser = false;
      
      if (error.response?.status === 400) {
        this.$refs.alert.show(
          "Erro",
          "Você já compartilhou com este usuário!",
          null,
          3000,
          "bg-danger"
        );
      } else {
        this.$refs.alert.show(
          "Erro",
          "Erro ao compartilhar dispositivo",
          null,
          3000,
          "bg-danger"
        );
      }
    },

    handleError(error, defaultMessage) {
      console.error("ShareDeviceModal Error:", error);
      this.$refs.alert.show(
        "Erro",
        error.response?.data?.message || defaultMessage,
        null,
        3000,
        "bg-danger"
      );
    }
  }
};
</script>

<style scoped>
.shared-users-container {
  max-height: 200px;
  overflow-y: scroll;
  padding-right: 8px;
}

/* Estilos do scroll - sempre visível e verde */
.shared-users-container::-webkit-scrollbar {
  width: 8px;
}

.shared-users-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.shared-users-container::-webkit-scrollbar-thumb {
  background: #006035;
  border-radius: 4px;
}

.shared-users-container::-webkit-scrollbar-thumb:hover {
  background: #004d2a;
}

.shared-user-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

.shared-user-card:hover {
  background: #e9ecef;
  border-color: #dee2e6;
}

.user-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.user-avatar {
  width: 40px;
  height: 40px;
  background: #006035;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  margin-right: 12px;
  font-size: 18px;
}

.user-details {
  display: flex;
  flex-direction: column;
}

.user-name {
  font-weight: 600;
  color: #495057;
  font-size: 14px;
}

.user-code {
  color: #6c757d;
  font-size: 12px;
}

.remove-btn {
  border-radius: 6px;
  padding: 6px 8px;
}

.search-section {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.input-group .form-control:focus {
  border-color: #006035;
  box-shadow: 0 0 0 0.2rem rgba(0, 96, 53, 0.25);
}


.confirmation-avatar {
  background: #28a745 !important;
}

.confirmation-style {
  background: white;
  border-radius: 8px;
}

.confirmation-btn {
  font-size: 12px;
  padding: 8px;
  min-width: auto;
}

.action-buttons {
  display: flex;
  align-items: center;
}

@media (max-width: 768px) {
  .modal-dialog {
    margin: 10px;
    max-width: calc(100vw - 20px);
  }
  
  .modal-header {
    padding: 15px;
    flex-direction: column;
    align-items: flex-start;
  }
  
  .modal-header .btn-close {
    position: absolute;
    top: 15px;
    right: 15px;
    margin: 0;
  }
  
  .modal-title {
    font-size: 18px;
    margin-bottom: 5px !important;
  }
  
  .modal-body {
    padding: 15px;
  }

  .shared-user-card {
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 12px 15px;
  }
  
  .user-info {
    flex: 1;
    min-width: 0;
  }
  
  .user-avatar {
    width: 35px;
    height: 35px;
    font-size: 16px;
    flex-shrink: 0;
  }
  
  .user-details {
    flex: 1;
    min-width: 0;
  }
  
  .user-name {
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .user-code {
    font-size: 11px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
  .remove-btn {
    flex-shrink: 0;
    padding: 6px 10px;
    font-size: 12px;
    min-width: auto;
  }

  .search-section {
    padding: 12px;
    margin-bottom: 12px;
  }
  
  .input-group .form-control {
    font-size: 16px;
    padding: 12px;
  }
  
  .input-group .btn {
    padding: 12px 15px;
    font-size: 14px;
  }

  .confirmation-style {
    margin-bottom: 0;
    margin-top: 16px;
  }

  .shared-users-container {
    max-height: 250px;
    padding-right: 5px;
  }
  
  .mb-4 {
    margin-bottom: 1.5rem !important;
  }
  
  .mb-3 {
    margin-bottom: 1rem !important;
  }

  h6 {
    font-size: 16px;
    font-weight: 600;
  }
}

@media (max-width: 480px) {
  .modal-dialog {
    margin: 5px;
    max-width: calc(100vw - 10px);
  }
  
  .shared-user-card {
    padding: 10px 12px;
    gap: 8px;
  }
  
  .user-avatar {
    width: 32px;
    height: 32px;
    font-size: 14px;
  }
  
  .user-name {
    font-size: 13px;
  }
  
  .user-code {
    font-size: 10px;
  }
  
  .remove-btn {
    padding: 4px 8px;
    font-size: 11px;
  }
  
  .search-section {
    padding: 10px;
  }
  
  .confirmation-btn {
    font-size: 10px;
    padding: 6px;
  }
}

/* Melhorias nos botões */
.btn-outline-success:hover {
  background-color: #006035;
  border-color: #006035;
}

.btn-success {
  background-color: #006035;
  border-color: #006035;
}

.btn-success:hover {
  background-color: #004d2a;
  border-color: #004d2a;
}
</style>
